
import { defineComponent } from 'vue';
import { $api } from '@/common/apiService';
import { HomepageConfig } from '@/Models/HomepageConfig';
import { Image } from '@/Models/Image';
import SelectImageModal from './SelectImageModal.vue';

export default defineComponent({
  name: 'EditHomepageForm',
  components: { SelectImageModal },
  data() {
    return {
      form: {
        welcomeTitle: '',
        welcomeText: '',
        uploadPrompt: '',
        frontpageImageIds: [],
      } as HomepageConfig,
      allImages: [] as Image[],
      frontpageImages: [] as Image[],
      token: '',
      showImageModal: false,
      saving: false,
      successMessage: '',
      errorMessage: '',
    };
  },
  async mounted() {
    this.token = this.$store.getters.getSasToken;

    const trips = await $api.trips.fetch();
    if (!trips || trips.length === 0) return;

    const today = new Date();
    const past = trips.filter(t => new Date(t.startDate) < today);

    const pastTrip = past[0] ?? null;
    
    const [config, images] = await Promise.all([
      $api.homepageConfig.get(),
      $api.images.fetch(pastTrip.year),
    ]);

    if (images) this.allImages = images;
    if (config) {
      this.form = { ...config };
      this.syncFrontpageImages();
    }
  },
  methods: {
    syncFrontpageImages() {
      this.frontpageImages = this.form.frontpageImageIds
        .map(id => this.allImages.find(img => img.id === id))
        .filter((img): img is Image => img !== undefined);
    },

    addImage(image: Image) {
      if (!this.form.frontpageImageIds.includes(image.id)) {
        this.form.frontpageImageIds.push(image.id);
        this.frontpageImages.push(image);
      }
    },

    removeImage(idx: number) {
      this.form.frontpageImageIds.splice(idx, 1);
      this.frontpageImages.splice(idx, 1);
    },

    moveUp(idx: number) {
      if (idx === 0) return;
      [this.form.frontpageImageIds[idx - 1], this.form.frontpageImageIds[idx]] =
        [this.form.frontpageImageIds[idx], this.form.frontpageImageIds[idx - 1]];
      [this.frontpageImages[idx - 1], this.frontpageImages[idx]] =
        [this.frontpageImages[idx], this.frontpageImages[idx - 1]];
    },

    moveDown(idx: number) {
      if (idx === this.frontpageImages.length - 1) return;
      [this.form.frontpageImageIds[idx], this.form.frontpageImageIds[idx + 1]] =
        [this.form.frontpageImageIds[idx + 1], this.form.frontpageImageIds[idx]];
      [this.frontpageImages[idx], this.frontpageImages[idx + 1]] =
        [this.frontpageImages[idx + 1], this.frontpageImages[idx]];
    },

    async save() {
      this.saving = true;
      this.successMessage = '';
      this.errorMessage = '';

      const result = await $api.homepageConfig.save(this.form);

      this.saving = false;
      if (result) {
        this.form = { ...result };
        this.syncFrontpageImages();
        this.successMessage = 'Ændringer gemt.';
      } else {
        this.errorMessage = 'Der opstod en fejl. Prøv igen.';
      }
    },
  },
});
